import { RetailerPartnerType } from '../enum/index.js';
import { amazonFreshCheckout, checkoutWithAmazon } from './amazon-fresh-checkout.js';
import instacartCheckout from './instacart-checkout.js';
import krogerCheckout from './kroger-checkout.js';
import targetCheckout from './target-checkout.js';
import walmartCheckout from './walmart-checkout.js';
const checkoutServices = {
    [RetailerPartnerType.AMAZON_FRESH]: amazonFreshCheckout,
    [RetailerPartnerType.INSTACART]: instacartCheckout,
    [RetailerPartnerType.KROGER]: krogerCheckout,
    [RetailerPartnerType.TARGET]: targetCheckout,
    [RetailerPartnerType.WALMART]: walmartCheckout
};
export { checkoutServices, amazonFreshCheckout, checkoutWithAmazon, instacartCheckout, krogerCheckout, targetCheckout, walmartCheckout };
export { initService as initInstacartService, destroyService } from './instacart-checkout.js';
export default checkoutServices;
